// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"currencyDropdown_dropdown__KqqOb"};